import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import Slider from "react-slick"
import { connect } from "react-redux"
import { history, withRouter, Link } from "react-router-dom"
import classNames from 'classnames';
import { getCollectionProductBrands, getCollectionList } from "../../../actions/kafairAction"
import styled from "styled-components"
import { getCloudImageUrl, emptyImage } from "../../../utils";
import FlashSaleImage from "../../../images/flashsale.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";
import RightArr from "../../../images/bca-raffle-arrow-right.png";
import LeftArr from "../../../images/bca-raffle-arrow-left.png";
import { TextRupiah } from "../../Text"

const PreviousArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 10px;
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      border-radius: 30px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    }

    @media (max-width: 480px) {
      img {
        width: 28px !important;
        height: 28px !important;
        position: absolute;
        left: -45px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      }
    }

    @media (max-width: 320px) {
      img {
        left: -45px !important;
        width: 28px !important;
        height: 28px !important;
        top: -3px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={LeftArr} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      border-radius: 30px;
      right: -5px;
      position: absolute;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    }

    @media (max-width: 480px) {
      img {
        right: -10px !important;
        width: 28px !important;
        height: 28px !important;
        top: -3px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      }
    }

    @media (max-width: 320px) {
      img {
        right: -15px !important;
        width: 28px !important;
        height: 28px !important;
        top: -3px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={RightArr} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  arrows: true,
  // autoplay:true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: false,
  swipe: true,
  fade: false,
  prevArrow: <PreviousArrow />,
  nextArrow: <NextArrow />,
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ],
};

function UnderRetail({ backgroundColor, title, history, slug, getCollectionProductBrands, name, dataKaFair, dataCategory, getCollectionList, ...props }) {

  const [image, setImage] = useState([])
  const [description, setDescription] = useState("")
  const [backgroundImage, setBackgroundImage] = useState([])
  const [sectionName, setSectionName] = useState("")

  useEffect(() => {
    fetchData()
  }, [slug])

  function fetchData() {
    let payload = {}
    if (name === "under_retail") {
      payload = {
        collection: slug,
        collection_type: "product_variants",
        pre_verified: true,
        availables: true
      }
    } else {
      payload = {
        collection: slug,
        collection_type: "product_variants",
        availables: true
      }
    }

    getCollectionProductBrands(payload, name)
      .then(_ => getCollectionList("kafair", slug, {}, name)
      )
      .then(({ value }) => {
        setSectionName(value.data.name)

        setDescription(value.data.description)

        setBackgroundImage(value.data.categories[0].pivot.images)

        let image = value.data.default_images

        setImage(image)

      })
      .catch(e => null)
  }

  function goToPageDetail() {
    window.open(`/bcaxkickavenue/${slug}`, "_blank");
  }

  function goToProductDetail(category, id, slug) {
    const categoryUrl =
      category === "apparels" || category === "Apparels"
        ? "apparel"
        : category === "lifestyles"
          ? "electronics-collectibles"
          : category === "handbags"
            ? "luxury"
            : category;

    if (name === "under_retail") {
      window.location.href = `/${categoryUrl}/${id}/${slug}?pre_verified=true?product=under-retail`
    } else {
      window.location.href = `/${categoryUrl}/${id}/${slug}`
    }
  }

  function splitText() {
    let split = sectionName.split(" ")

    if (split.length > 0) {
      if (split.length >= 3 && name !== "under_retail") {
        return (
          <h3 style={window.screen.availWidth > 480 ? { color: name === "merchandise" ? "#1f9d59" : "#fff" } : { color: name === "merchandise" ? "#1f9d59" : "#fff" }}><span>{sectionName.split(" ")[0].toUpperCase()} </span>
            <span>{sectionName.split(" ")[1].toUpperCase()}</span>
            <br />{sectionName.split(" ")[2].toUpperCase()}</h3>
        )
      } else {
        return (
          <h3 style={window.screen.availWidth > 480 ?
            {
              color: name === "merchandise" ? "#1f9d59" : "#fff"
            }
            :
            {
              color: name === "merchandise" ? "#1f9d59" : "#fff"
            }}><span>{sectionName.split(" ")[0].toUpperCase()} </span><br />{sectionName.split(" ")[1].toUpperCase()}</h3>
        )
      }
    }
  }

  if (!title || !description) return null

  return (
    <div
      className={`under-retail__section ${props.classname}`}
      style={{ backgroundImage: backgroundImage && backgroundImage[0] && backgroundImage[0].URL ? `url("${window.screen.availWidth > 480 ? backgroundImage.find(item => item.orientation === "landscape").URL : backgroundImage.find(item => item.orientation === "portrait").URL}")` : null, backgroundSize: "cover", boxShadow: name !== "under_retail" && "0 1px 3px 0 rgba(0, 0, 0, 0.16)" }}>
      <div className="products-container">
        <div className="under-retail__description">
          {
            splitText()
          }
          {
            name === "under_retail" ?
              <p style={window.screen.availWidth > 480 ? { color: name === "merchandise" ? "#1f9d59" : "#fff", fontSize: name === "merchandise" ? "16px" : null } : { color: name === "merchandise" ? "#1f9d59" : "#fff", fontSize: name === "merchandise" ? "12px" : null }}>{description}</p> : <p style={window.screen.availWidth > 480 ? { color: name === "merchandise" ? "#1f9d59" : "#fff", fontSize: name === "merchandise" ? "16px" : null } : { color: name === "merchandise" ? "#1f9d59" : "#fff", fontSize: name === "merchandise" ? "12px" : null }}>{description}</p>
          }
        </div>
        <Slider {...settings}>
          {
            dataKaFair && dataKaFair[`${name}`] && dataKaFair[`${name}`].data && dataKaFair[`${name}`].data.map((item, index) => {
              const categoryUrl = item.product.category.name === "apparels" || item.product.category.name === "Apparels" ? "apparel" : item.product.category.name === "lifestyles" ? "electronics-collectibles" : item.product.category.name === "handbags" ? "luxury" : item.product.category.name;
              const productDetailUrl = name === "under_retail" ? `/${categoryUrl}/${item.id}/${item.slug}?pre_verified=true?product=under-retail` : `/${categoryUrl}/${item.id}/${item.slug}`;

              return <a {
                ... {
                  href: productDetailUrl
                }
              } onClick={() => goToProductDetail(item.product.category.name, item.id, item.slug)} key={item.id} className="single-product-section">
                <div className="single-product-container">
                  <h5 className="product-brand">{item.product.brand ? item.product.brand.flat.length > 0 && item.product.brand.flat[0] : ""}</h5>
                  <h5 className="product-name">{item.display_name}</h5>
                  <KickImage className="product-img" src={item.product_variant_images.length > 0 && new RegExp("\\b" + "s3.amazonaws.com" + "\\b").test(item.product_variant_images[0].URL)
                    ? getCloudImageUrl(
                      item.product_variant_images[0].URL,
                      400
                    )
                    : emptyImage(dataCategory)} alt="" />
                  <div className="product-price-flex">
                    {
                      name === "under_retail" &&
                      <h5 style={{ marginRight: window.screen.availWidth > 480 ? "10px" : "5px", fontSize: window.screen.availWidth < 480 && "10px" }}><strike style={{ color: "#adadad" }}>{
                        item.retail_price > 0 ? <TextRupiah
                          prefix="IDR. "
                          color="#adadad"
                          align="center"
                          value={item.retail_price && item.retail_price.toString() * 14400}
                          bold={true}
                          isFormatRupiah
                        /> : <TextRupiah
                          prefix="IDR. "
                          color="grey"
                          align="center"
                          value={"0"}
                          bold={true}
                          isFormatRupiah
                        />
                      }</strike></h5>
                    }
                    <h5 style={{ marginTop: name !== "under_retail" && "0", fontSize: window.screen.availWidth < 480 && "12px" }} className="real-price">{
                      item.price > 0 ? <TextRupiah
                        prefix="IDR. "
                        color="#242424"
                        align="center"
                        value={item.price && item.price.toString()}
                        bold={true}
                        isFormatRupiah
                      /> : "IDR. 0"
                    }</h5>
                  </div>
                </div>
              </a>
            })
          }
          <div onClick={() => goToPageDetail()} className="single-product-section">
            <div className={classNames("single-product-showAll", { "is-under-retail": name === "under_retail" })}>
              <h4 className="under-retail__showAll">Show All</h4>
              <h4 className="under-retail__sectionName">{name.toLowerCase().replace(/([^a-z]|^)([a-z])(?=[a-z]{2})/g, function (_, word1, word2) {
                return word1 + word2.toUpperCase();
              }).replace("_", " ")}</h4>
            </div>
          </div>
        </Slider>

      </div>
      <div onClick={() => goToPageDetail()} className="under-retail__viewAll">
        <p style={{ color: name === "under_retail" ? "#fff" : "#242424", position: "relative", zIndex: "1000" }}>View All</p>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  dataKaFair: state.dataKaFair,
  dataCategory: state.dataCategory.selected
})

const mapDispatchToProps = dispatch => ({
  getCollectionProductBrands: (payload, name) => dispatch(getCollectionProductBrands(payload, name)),
  getCollectionList: (category, slug, payload, name) => dispatch(getCollectionList(category, slug, payload, name))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnderRetail))
